export type ImportStatement<T> = () => Promise<{
    default: React.ComponentClass<T>;
}>;

export class ViewsManager {
    private views: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: React.ComponentClass<any> | undefined;
    } = {};

    public async loadAndSaveModule<T>(viewName: string, importMethod: ImportStatement<T>) {
        if (!this.views[viewName]) {
            const module = await importMethod();
            
            this.views[viewName] = module.default;
        }
    }

    public getView(viewName: string) {
        return this.views[viewName];
    }
}

export default new ViewsManager();
